import { render } from "./QuizGenderField.vue?vue&type=template&id=2f8317c0"
import script from "./QuizGenderField.vue?vue&type=script&lang=js"
export * from "./QuizGenderField.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__